module.exports = __webpack_public_path__ + "img/Classroom1.0cf9eaef.png";